/**
 * Created by karora on 20/03/17.
 */
import { Component, OnInit } from '@angular/core';

import { ProfileService } from '../services/profile.service';

@Component({
  selector: 'top-menu',
  template: `<ul>
  <li routerLink="/dashboard" routerLinkActive="active">Dashboard</li>
  <li routerLink="/hubs/all" routerLinkActive="active">Hubs</li>
  <li routerLink="/issues" routerLinkActive="active">Issues</li>
  <li routerLink="/messages" routerLinkActive="active">Messages</li>
  <li routerLink="/stock/summary" routerLinkActive="active">Stock</li>
  <li routerLink="/allmeters" routerLinkActive="active">Meter Readings</li>
  <li routerLink="/firmwaresets" routerLinkActive="active">Firmware Sets</li>
  <li routerLink="/lookups/customer_types" routerLinkActive="active">Lookup Tables</li>
  <li routerLink="/mastersheet" routerLinkActive="active">Master Sheet</li>
  <ng-container *ngIf="CanAdminister()">
    <li routerLink="/admin/profiles" routerLinkActive="active">Admin</li>
  </ng-container>
  <li onclick="window.open('/a/signature.html','HubEMailSignature');"><a href="/a/signature.html" target="_blank">Signature</a></li>
  <li onclick="window.location = '/auth/logout';"><a href="/auth/logout">Log Out</a></li>
</ul>
`,
  styles: [
    `:host { background: #F04E98; color: white; position: fixed; right: auto; top: 0px; left: 0px; bottom: 0; width: 15em;
      z-index: 99; font-family: Poppins, Arial, "Helvetica Neue", Helvetica, sans-serif; font-weight: bold; }`,
    `ul { font-size: 130%; line-height: 2em; padding-top: 64px; padding-left: 0; }`,
    `li { margin: 0; padding-left: 2em; }`,
    `li:hover { color: #1b1b1b; background-color: #FFCD00; }`
  ]
})

export class MenuComponent implements OnInit {
  CanAdminister = ProfileService.CanAdminister;

  constructor() { }
  ngOnInit(): void { }
}
